<app-styleguide-specimen [rendering]="rendering" e2eId="styleguide-tracking">
  <p *ngIf="disconnectedMode">The tracking API is only available in connected, integrated, or headless modes.</p>

  <div *ngIf="!disconnectedMode">
    <p class="alert alert-warning">
      Note: The JSS tracker API is disabled by default. Consult the <a href="https://jss.sitecore.com/docs/fundamentals/services/tracking">tracking documentation</a> to enable it.
    </p>
    <div class="row">
      <fieldset class="form-group col-sm">
        <legend>Event</legend>
        <p>
          Events are defined in <code>/sitecore/system/Settings/Analytics/Page Events</code>
        </p>
        <label htmlFor="event">Event GUID or Name</label>
        <input type="text" id="event" class="form-control" [(ngModel)]="event" />
        <button
          type="button"
          class="btn btn-primary mt-3"
          (click)="submitEvent()"
        >
          Submit
        </button>
      </fieldset>

      <fieldset class="form-group col-sm">
        <legend>Goal</legend>
        <p>
          Goals are defined in <code>/sitecore/system/Marketing Control Panel/Goals</code>
        </p>
        <label htmlFor="goal">Goal GUID or Name</label>
        <input
          type="text"
          class="form-control"
          id="goal"
          name="goal"
          [(ngModel)]="goal"
          placeholder="i.e. Register"
        />
        <button
          type="button"
          class="btn btn-primary mt-3"
          (click)="submitGoal()"
        >
          Submit
        </button>
      </fieldset>
    </div>
    <div class="row">
      <fieldset class="form-group col-sm">
        <legend>Outcome</legend>
        <p>
          Outcomes are defined in <code>/sitecore/system/Marketing Control Panel/Outcomes</code>
        </p>
        <label htmlFor="outcomeName">Outcome GUID or Name</label>
        <input
          type="text"
          class="form-control"
          id="outcomeName"
          name="outcomeName"
          [(ngModel)]="outcomeName"
          placeholder="i.e. Marketing Lead"
        />
        <br />
        <label htmlFor="outcomeValue">Monetary Value (optional)</label>
        <input
          type="number"
          class="form-control"
          id="outcomeValue"
          name="outcomeValue"
          [(ngModel)]="outcomeValue"
          placeholder="i.e. 1337.00"
        />
        <button
          type="button"
          class="btn btn-primary mt-3"
          (click)="submitOutcome()"
        >
          Submit
        </button>
      </fieldset>

      <fieldset class="form-group col-sm">
        <legend>Campaign</legend>
        <p>
          Campaigns are defined in <code>/sitecore/system/Marketing Control Panel/Campaigns</code>
        </p>
        <label htmlFor="campaign">Campaign GUID or Name</label>
        <input type="text" class="form-control" id="campaign" [(ngModel)]="campaign" />
        <button
          type="button"
          class="btn btn-primary mt-3"
          (click)="triggerCampaign()"
        >
          Submit
        </button>
      </fieldset>
    </div>
    <div class="row">
      <fieldset class="form-group col-sm">
        <legend>Page View</legend>
        <p>
          Track arbitrary page views for custom routing or offline use. Note that Layout
          Service tracks page views by default unless <code>tracking=false</code> is passed
          in its query string.
        </p>
        <label htmlFor="pageId">Page Item GUID</label>
        <input
          type="text"
          class="form-control"
          id="pageId"
          name="pageId"
          [(ngModel)]="pageId"
          placeholder="i.e. 11111111-1111-1111-1111-111111111111"
        />
        <br />
        <label htmlFor="pageUrl">Page URL</label>
        <input
          type="text"
          class="form-control"
          id="pageUrl"
          name="pageUrl"
          [(ngModel)]="pageUrl"
          placeholder="i.e. /foo/bar"
        />
        <button
          type="button"
          class="btn btn-primary mt-3"
          (click)="submitPageView()"
        >
          Submit
        </button>
      </fieldset>

      <fieldset class="form-group col-sm">
        <legend>Batching</legend>
        <p>
          The tracking API supports pushing a whole batch of events in a single request.
          This can be useful for queuing strategies or offline PWA usage.
        </p>
        <button
          type="button"
          class="btn btn-primary"
          (click)="submitBatching()"
        >
          Submit Batch of Events
        </button>
      </fieldset>
    </div>
    <div class="row">
      <fieldset class="form-group col-sm">
        <legend>Interaction Control</legend>
        <p>
          Tracking data is not pushed into the xConnect service until your session ends on
          the Sitecore server. Click this button to instantly end your session and flush the
          data - great for debugging and testing.
        </p>
        <p class="alert alert-warning">
          Note: By default <em>anonymous</em> contacts will not be shown in Experience
          Profile. If your interactions are not showing up in Experience Profile, you may
          need to
          <a href="https://doc.sitecore.net/developers/xp/xconnect/xconnect-search-indexer/enable-anonymous-contact-indexing.html">
            enable anonymous contact indexing.
          </a>
        </p>
        <button
          type="button"
          class="btn btn-primary"
          (click)="abandonSession()"
        >
          End Interaction
        </button>
      </fieldset>
    </div>
  </div>
</app-styleguide-specimen>
